import React, { useEffect, useState } from "react";
import axios from "axios";

const Partner = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        const fetchPartners = async () => {
            try {
                // Check localStorage for cached data and timestamp
                const cachedPartners = localStorage.getItem('partnersData');
                const cacheTimestamp = localStorage.getItem('partnersDataTimestamp');
                const now = Date.now();
                const THIRTY_MINUTES = 30 * 60 * 1000;

                if (cachedPartners && cacheTimestamp && (now - parseInt(cacheTimestamp) < THIRTY_MINUTES)) {
                    setPartners(JSON.parse(cachedPartners));
                } else {
                    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
                    const Url = process.env.REACT_APP_API_VISA_PARTNER;
                    const response = await axios.get(`${apiBaseUrl}${Url}`);

                    setPartners(response.data);
                    // Save data and timestamp in localStorage
                    localStorage.setItem('partnersData', JSON.stringify(response.data));
                    localStorage.setItem('partnersDataTimestamp', now.toString());
                }
            } catch (error) {
                console.error("Error fetching API", error);
            }
        };

        fetchPartners();
    }, []);

    return (
        <div className="partner-area py-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 mx-auto">
                        <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s">
                            <span className="site-title-tagline"><i className="far fa-passport"></i> আমাদের সহযোগী সংগঠনসমূহ</span>
                            <h2 className="site-title">আমাদের সহযোগী সংগঠনসমূহ</h2>
                        </div>
                    </div>
                </div>
                <div className="row g-4 justify-content-center wow fadeInUp" data-wow-delay=".25s">
                    {partners.map((partner, index) => (
                        <div className="col-4 col-lg-2" key={index}>
                            <div className="">
                                <img width={100} src={`${backendBaseUrl}${partner?.image}`} alt={partner?.name} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Partner;
